import { createContext, useMemo, type PropsWithChildren } from "react";

import { useCarriersQuery } from "../hooks/useCarriersQuery";

import type { Carrier } from "../types";

export interface CarriersContextValue {
  carriers: Carrier[];
  loading: boolean;
  error: string | null;
}

export const CarriersContext = createContext<CarriersContextValue | undefined>(
  undefined,
);

export function CarriersProvider({
  children,
}: PropsWithChildren): React.JSX.Element {
  const { carriers, loading, error } = useCarriersQuery();

  const value = useMemo<CarriersContextValue>(
    () => ({ carriers, loading, error }),
    [carriers, loading, error],
  );

  return (
    <CarriersContext.Provider value={value}>
      {children}
    </CarriersContext.Provider>
  );
}
